import React, { useContext, useState } from 'react';
import { AuthContext } from '../../context';
import Layout from "../../components/global/Layout";
import { Redirect } from "react-router-dom";
import { history } from '../../helpers'


function LogOutPage({ history }) {
   console.log('fff');
   // const context = useContext(AuthContext);
   // context.logout();
   return (
      <Layout styleId="logout-page">
      </Layout>
   )
}
export default LogOutPage;
